<div class="row d-flex flex-wrap align-items-end cabecalho-respostas">
    <div class="{{userService.userHasCashback() ? 'col-md-6' : 'col-md-9'}}">
        @if (!this.cotacaoSelecionada || !respostaTipoAlerta.tem_resposta) {
            <p class="text-center mb-0">
                <b>{{ 'buyer.cotacao.area-respostas.nenhuma-resposta.titulo' | translate}}</b>
                <br />
                {{ 'buyer.cotacao.area-respostas.nenhuma-resposta.subtitulo' | translate}}
            </p>
        }
        @if (this.cotacaoSelecionada && respostaTipoAlerta.tem_resposta) {
            <div>
                @if (respostaTipoAlerta.tipo_alerta == 'total_pe') {
                    <div role="alert" class="alert alert-success">
                        <i class="fa fa-info"></i> <strong>{{ 'buyer.cotacao.area-respostas.alerta.aviso' | translate}}</strong>
                        {{ 'buyer.cotacao.area-respostas.alerta.total_pe' | translate}}
                    </div>
                }
                @if (respostaTipoAlerta.tipo_alerta == 'maioria_pe') {
                    <div role="alert" class="alert alert-success">
                        <i class="fa fa-info"></i> <strong>{{ 'buyer.cotacao.area-respostas.alerta.aviso' | translate}}</strong>
                        {{ 'buyer.cotacao.area-respostas.alerta.maioria_pe' | translate}}
                    </div>
                }
                @if (respostaTipoAlerta.tipo_alerta == 'total_pf') {
                    <div role="alert" class="alert alert-warning">
                        <i class="fa fa-info"></i> <strong>{{ 'buyer.cotacao.area-respostas.alerta.aviso' | translate}}</strong>
                        {{ 'buyer.cotacao.area-respostas.alerta.total_pf' | translate}}
                    </div>
                }
                @if (respostaTipoAlerta.tipo_alerta == 'maioria_pf') {
                    <div role="alert" class="alert alert-warning">
                        <i class="fa fa-info"></i> <strong>{{ 'buyer.cotacao.area-respostas.alerta.aviso' | translate}}</strong>
                        {{ 'buyer.cotacao.area-respostas.alerta.maioria_pf' | translate}}
                    </div>
                }
                @if (respostaTipoAlerta.tipo_alerta == 'faltam_pecas') {
                    <div role="alert" class="margtop10 alert alert-danger" (click)="modal_abrir()">
                        <i class="fa fa-info"></i> <strong>{{ 'buyer.cotacao.area-respostas.alerta.aviso' | translate}}</strong>
                        {{ 'buyer.cotacao.area-respostas.alerta.vermelho.parte1' | translate}}
                        <b>{{translateFaltamPecas}}</b>
                        {{ 'buyer.cotacao.area-respostas.alerta.vermelho.parte3' | translate}}
                    </div>
                }
            </div>
        }
    </div>
    <div class="form-group row ordenacao btn-sm {{userService.userHasCashback() ? 'col-md-6' : 'col-md-3'}}">
        <div class="form-control-content col">
            <label for="ddlFiltro">{{ 'buyer.cotacao.area-respostas.filtro.label' | translate}}</label>
            <select id="ddlFiltro" class="form-select tipo_ordenacao" [(ngModel)]="searchType">
                <option value="1">{{ 'buyer.cotacao.area-respostas.filtro.todas' | translate}}</option>
                <option value="2">{{ 'buyer.cotacao.area-respostas.filtro.genuinas' | translate}}</option>
                <option value="3">{{ 'buyer.cotacao.area-respostas.filtro.outras' | translate}}</option>
            </select>
        </div>
        @if (userService.userHasCashback()) {
            <div class="form-control-content col">
                <label for="ddlOrdenacao">{{ 'buyer.cotacao.area-respostas.ordenacao.label' | translate}}</label>
                <select id="ddlOrdenacao" class="form-select tipo_ordenacao" [(ngModel)]="orderType" (change)="executeSort(orderType)">
                    <option value="1">{{ 'buyer.cotacao.area-respostas.ordenacao.cashback' | translate}}</option>
                    <option value="2">{{ 'buyer.cotacao.area-respostas.ordenacao.score' | translate}}</option>
                    <option value="3">{{ 'buyer.cotacao.area-respostas.ordenacao.preco' | translate}}</option>
                </select>
            </div>
        }
    </div>
</div>

<ng-template #templatePecasFaltantes>
    <div class="modal-header">
        <h4 class="modal-title">{{'buyer.cotacao.area-respostas.alerta.vermelho.titulo' | translate}}</h4>
        <button type="button" class="btn-close" (click)="modal_fechar();"></button>
    </div>
    <div class="modal-body" style="height: 300px;">
        <div class="card-body">
            <ng-scrollbar style="height: 250px;">
                <ul style="color:#656565;">
                    @for (peca of respostaTipoAlerta.nao_encontradas; track peca) {
                        <li>{{peca}}</li>
                    }
                </ul>
            </ng-scrollbar>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="modal_fechar()">{{'elemento.generico-botao.fechar' | translate}}</button>
    </div>
</ng-template>
